module.exports = __webpack_public_path__ + "img/1560995601.76fb07a6.jpg";